module.exports = __webpack_public_path__ + "static/media/zyrgon.a793036f.webp";